<template>
  <v-container fluid>
    <v-form :readonly="true">
      <v-row dense>
        <v-col cols="12">
          <v-card class="rounded-lg">
            <v-card-title class="am-t2 bold">
              <v-row dense class="space-between align-center">
                <div>Références de l'association (Papier)</div>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-col>
                <v-row dense>
                  <v-col cols="6">
                    <v-text-field
                      dense
                      filled
                      label="Numéro volume"
                      :value="reprise?.numeroVolume"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      dense
                      filled
                      label="Numéro folio"
                      :value="reprise?.numeroFolio"
                    />
                  </v-col>
                  <v-col cols="12"/>
                </v-row>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" v-if="reprise.registre?.length">
          <v-card class="rounded-lg">
            <v-card-title class="am-t2 bold">
              <v-row dense class="space-between align-center">
                <div>Évènements</div>
              </v-row>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="reprise?.registre"
              :items-per-page="itemsPerPage"
              :sort-by="sortBy"
              :sort-desc="sortDesc"
              :expanded.sync="expanded"
              single-expand
              show-expand
              must-sort
              @click:row="etend"
              :footer-props="{
                'items-per-page-options': [-1, 10, 20, 50],
              }"
            >
              <template #item.date="{ item }">
                {{ item.date | date }}
              </template>
              <template #item.dateAg="{ item }">
                {{ item.dateAg | date }}
              </template>

              <template #expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <p class="ma-2">
                 <pre>{{item.texte}}</pre>
                  </p>
                </td>
              </template>

              <template #item.data-table-expand="{ item, isExpanded }">
                <v-btn v-if="item.texte" icon>
                  <v-icon
                    :class="{
                      'v-data-table__expand-icon': true,
                      'v-data-table__expand-icon--active': isExpanded,
                    }"
                  >
                    mdi-chevron-down
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
export default {
  props: {
    reprise: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      expanded: [],
      itemsPerPage: 20,
      sortBy: "date",
      sortDesc: true,
      headers: [
        {
          text: "Évènement",
          value: "evenement",
          sortable: true,
        },
        {
          text: "Type",
          value: "type",
          sortable: true,
        },
        {
          text: "Date",
          value: "date",
          sortable: true,
          align: "center",
        },
        {
          text: "Date Assemblée Générale",
          value: "dateAg",
          sortable: true,
          align: "center",
        },
      ],
    }
  },
  methods: {
    etend(a, row) {
      if (a.texte) {
        row.expand(!row.isExpanded);
      }
    },
  },
};
</script>
